import React from 'react';
import { Button, Link as VitaLink, pxToRem } from '@modernhealth/vital-components';
import { Trans, useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { navigationService } from 'src/config/rootService';

import { ErrorView } from './ErrorView';
import conversationNotFound from '../assets/conversation-not-found.svg';

const StyledButton = styled(Button)`
    margin: ${pxToRem(8, 0)};
`;

const StyledLink = styled.a`
    font-size: inherit;
`;

const HelpEmailLink: React.FC = ({ children }) => (
    <VitaLink>
        <StyledLink href="mailto:help@joinmodernhealth.com">{children}</StyledLink>
    </VitaLink>
);

export const ConversationNotFound: React.FC = () => {
    const { t } = useTranslation();

    return (
        <ErrorView
            imgSrc={conversationNotFound}
            title={t('messaging:conversation_not_found.title')}
            description={t('messaging:conversation_not_found.description')}
            buttons={
                <>
                    <StyledButton
                        role="link"
                        fluid
                        onClick={() => {
                            navigationService.navigate('/messages');
                        }}
                    >
                        {t('messaging:conversation_not_found.button.continue_to_messages')}
                    </StyledButton>
                    <StyledButton
                        role="link"
                        fluid
                        variant="secondary"
                        onClick={() => {
                            navigationService.navigate('/dashboard');
                        }}
                    >
                        {t('messaging:conversation_not_found.button.return_to_home')}
                    </StyledButton>
                </>
            }
            footnote={
                <Trans
                    t={t}
                    i18nKey="messaging:conversation_not_found.footnote"
                    components={{
                        'email-link': <HelpEmailLink />,
                    }}
                />
            }
        />
    );
};
